module.exports = __webpack_public_path__ + "assets/loop-setting-grid.32326fa6.svg";